var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20034_73389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20034_73389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 6.27067L10.3214 4.04122L11.1971 3.16558C11.3885 2.97414 11.6244 2.87842 11.9047 2.87842C12.1851 2.87842 12.421 2.97414 12.6124 3.16558L13.4368 3.98993C13.6282 4.18138 13.7274 4.41385 13.7342 4.68735C13.741 4.96085 13.6487 5.19332 13.4573 5.38477L12.5714 6.27067ZM3.0381 14.1668C2.86631 14.1668 2.72294 14.1093 2.60798 13.9944C2.49302 13.8794 2.43555 13.736 2.43555 13.5642V12.1681C2.43555 12.0878 2.45007 12.0113 2.47913 11.9387C2.50819 11.866 2.55391 11.7985 2.61631 11.7361L9.59836 4.75402L11.8483 7.00398L4.86626 13.986C4.80387 14.0484 4.73636 14.0942 4.66371 14.1232C4.59106 14.1523 4.51456 14.1668 4.43421 14.1668H3.0381Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditFilled);
export default __webpack_public_path__ + "static/media/ic-edit-filled.1652dc9d70fa7a656df80db12299acde.svg";
export { ForwardRef as ReactComponent };